/// <amd-module name="ServiceHooks/Web/Admin/Context/ServiceHooksDataContext" />
import * as React from "react";
import { ObservableValue } from "VSS/Core/Observable";
import { IServiceHooksDataContext } from "./ServiceHooksDataContext.Types";

export const ServiceHooksDataContext = React.createContext<IServiceHooksDataContext>({
    dataLoaded: new ObservableValue(false),
    consumers: [],
    consumersById: {},
    consumerActions: [],
    consumerActionsById: {},
    eventTypes: [],
    eventTypesById: {}
});
